import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DataService } from '../../../core/data/data-service';
import { CommonService } from '../../../common/services/common.service';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { RouterConstants } from '../../../../app/core/routing/constants/app-paths.constant';
import { BannerCarouselService } from '../../../../app/core/routing/services/asset-library/banner-carousel.service';
import { BannerContent, BannerContentConfiguration, BannerContentGroupPage, BannerContentViewModel, CreateBannerContentResponse } from './interface/banner-carousel.i';
import { AssetLibraryConstants } from '../../../core/routing/services/asset-library/constants/asset-library.constant';
import { environment } from '../../../../environments/environment';
import { BannerPreview } from '../create-banner-carousel/interface/create-banner-carousel.i';
import { Utils } from '../../../common/utils/utils';
import { ProfileStoreService } from '../../create-profile/store/profile.store';
import { ProfileRequest, BannerCarousel, ProfileUpdateResponse } from '../../create-profile/interface/profile.i';
import { CreateProfileService } from '../../../core/routing/services/profile/create-profile.service';
import { SendToStoreService } from '../../../core/routing/services/asset-library/send-to-store.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageConstants } from '../../header/constants/lang.consts';
import { PageComponent } from '../page/page.component';


@Component({
  selector: 'iposcen-banner-carousel',
  templateUrl: './banner-carousel.component.html',
  styleUrls: ['./banner-carousel.component.scss']
})
export class BannerCarouselComponent implements OnInit, OnDestroy {
  @ViewChild('deleteModal') deleteModal: ElementRef;
  @ViewChild('showModal') showModal: ElementRef;
  @ViewChild('applyModal') applyModal: ElementRef;
  @ViewChild('sendToAccountModal') sendToAccountModal: ElementRef;
  @ViewChild('page1') page1: PageComponent;
  @ViewChild('page2') page2: PageComponent;
  @ViewChild('page3') page3: PageComponent;
  @Input() isDeviceBanner = false;
  @Output() readonly bannerDataForDevice = new EventEmitter();
  @Input() checkedId = new Map();
  @Output() readonly sendBannerLength = new EventEmitter();
  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  userRole = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  retailHqUser = GlobalConstants.RETAIL_HQ_USER;
  regionalHqUser = GlobalConstants.REGIONALHQ;
  configurations: BannerContentConfiguration[];
  radioType: string;
  tabIndex = 0;
  allBannerContentGroups: BannerContent[];
  bannerContentPages: string;
  bannerURLData: string;
  displayBannerContentGroups = [];
  selectedFiles: FileList;
  sideNav = 'banner';
  sortValue = GlobalConstants.CREATED_DATE;
  mediaObjects: any[] = [];
  page = 1;
  pageSize = 5;
  maxSize = 5;
  lCGlayout = 1;
  bannerCGToDelete: string;
  bannerCGToDeleteName: string;
  contentGrpData: object;
  pageType = GlobalConstants.BANNER_CONTENT_GROUP;
  editCheck: boolean;
  showBannerCarouselName: string;
  clickable = false;
  isNavigated: boolean = false;
  newContentGrpDataToNavigate: any;
  bannerFunction: string;
  pages: any;
  customURL: string;
  pageGrpForm: any;
  checkInd: number;
  checkInd2: number;
  details: string = ' Details';
  url = AssetLibraryConstants.S3_ASSET_LIBRARY_USERS + this.userId
    + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId;
  buttonName: string;
  currentdetailPage: string;
  presentPage: string;
  profile_page: string = GlobalConstants.PROFILE;
  assets_page: string = GlobalConstants.ASSET_LIBRARY;
  deviceTypes = GlobalConstants.DEVICE_TYPES;
  manufacturers = GlobalConstants.MANUFACTURERS;
  processors = GlobalConstants.PROCESSORS;
  generation = GlobalConstants.GENERATION;
  lockContentText = GlobalConstants.CONTENT_LOCKED;
  isStoreUser: boolean;
  showOnDeviceCount: number;
  bannerPreviewData: BannerPreview;
  imageURL: string;
  showDevice = false;
  newBannerContentTitle: string = $localize`:@@banner-carousel.tab-pane.new-banner-content-group:NEW BANNER CAROUSEL GROUP`;
  YES: string = GlobalConstants.YES;
  NO: string = GlobalConstants.NO;
  selctedContGrpsForProfile: any = {
    contentGrps: [],
    showOnDevice: []
  };
  sendButtonText: string;
  bannerCarouselIdInfo: string;
  sendNameToStore: string;
  retailHQUser: string;
  isRetailerUser: boolean;
  isSendToStore = false;
  optionalButton: string = GlobalConstants.OPTIONAL_TOOLTIP;
  showonDeviceDisabled = GlobalConstants.SHOW_ON_DEVICE_DISABLED;
  showonDeviceLimit = GlobalConstants.SHOW_ON_DEVICE_LIMIT;
  addToPackageLimit = GlobalConstants.ADD_TO_PACKAGE_LIMIT;
  deleteTooltipLabel = GlobalConstants.DELETE;
  editTooltipLabel = GlobalConstants.EDIT;
  createdDateVal = GlobalConstants.CREATED_DATE;
  groupNameVal = GlobalConstants.GROUP_NAME;
  profileDataSet: ProfileRequest;
  profileBannerCarouselData: BannerCarousel[];
  isPage3Created: boolean;
  bannerCorouselLabel = GlobalConstants.BANNER_CONTENT_GROUP_TEXT;
  isArabic = localStorage.getItem('preferredLanguage') === 'ar-sa';
  isHebrew = localStorage.getItem('preferredLanguage') === 'he';
  changePlacement: boolean;
  private ngUnsubscribe = new Subject<boolean>();
  pageError = new Map([[1, false], [2, false], [3, false]]);
  buttonLable = GlobalConstants.OK_BUTTON;
  errorMessageText = GlobalConstants.PAGE_ERROR_MESSAGE;
  errorMessageText1 = GlobalConstants.PAGE_ERROR_MESSAGE1;
  errorMessageText2 = GlobalConstants.PAGE_ERROR_MESSAGE2;
  errorMessageText3 = GlobalConstants.PAGE_ERROR_MESSAGE3;
  errorMessageText4 = GlobalConstants.PAGE_ERROR_MESSAGE4;
  errorMessageText5 = GlobalConstants.PAGE_ERROR_MESSAGE5;
  errorMessageText6 = GlobalConstants.PAGE_ERROR_MESSAGE6;
  profileNameValue = GlobalConstants.PROFILE_NAME_LOWER_CASE;
  internalName = GlobalConstants.INTERNAL_NAME;
  isRegionalHQ: boolean;
  globalconst = GlobalConstants;
  envurl = AssetLibraryConstants.S3_ASSET_LIBRARY_USERS + this.userId
    + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId
    + AssetLibraryConstants.BANNER_CONTENTS + AssetLibraryConstants.SLASH;
  deviceExists: boolean;
  whichPageDelete: any;
  pagelen: number;
  showPreviewLayout: boolean;

  constructor(
    private router: Router,
    private cmnService: CommonService,
    private bannerContentService: BannerCarouselService,
    private dataService: DataService,
    private profileStoreService: ProfileStoreService,
    private createProfileService: CreateProfileService,
    private sendToStoreService: SendToStoreService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.bannerCarouselIdInfo = '';
    if (this.isArabic || this.isHebrew) {
      this.changePlacement = true;
    }
    if (this.profileStoreService.currentWorkingProfile) {
      this.profileDataSet = JSON.parse(JSON.stringify(this.profileStoreService?.currentWorkingProfile));
    }
    this.retailHQUser = sessionStorage.getItem('userRole');
    this.isStoreUser = (sessionStorage.getItem(GlobalConstants.USER_ROLE) === GlobalConstants.STORE_USER) || false;
    this.isRetailerUser = (this.retailHQUser === 'retailHQUser') || false;
    this.isRegionalHQ = (this.retailHQUser === 'regionalHQ') || false;
    this.cmnService.pageObser
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((data) => {
      if(data.media.format === 'video/mp4' && ((data.previewType === GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS && data.fullScreenCheckbox) || (data.previewType === GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE && data.idleExpFullscreenEnabled))) {
        this.showPreviewLayout = false;
      } else {
        this.showPreviewLayout = true;
      }
    });    
    this.getAllBannerContentsByUser();
    this.showOnDeviceCount = 0;
    this.editCheck = false;
    this.customURL = '';
    this.pages = {};
    this.bannerFunction = GlobalConstants.CONTENT_PAGES;
    this.currentdetailPage = this.router.url;
    const pageName = this.currentdetailPage.lastIndexOf('/');
    if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.ASSET_LIBRARY) {
      this.presentPage = GlobalConstants.ASSET_LIBRARY;
    } else if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.CREATE_PROFILE ||
      this.currentdetailPage.includes(RouterConstants.EDIT_PROFILE)) {
      this.presentPage = GlobalConstants.PROFILE;
    }
    // listens image data from banner preview
    this.cmnService.pageDataTobannerObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        if (this.contentGrpData) {
          const bannerContent = this.contentGrpData[GlobalConstants.BANNER_CAROUSEL];
          if (typeof bannerContent.configurations === 'string') {
            bannerContent.configurations =
              JSON.parse(bannerContent.configurations) as BannerContentConfiguration;
          }
          this.customURL = res.data;
          bannerContent.configurations.customURL = res.data;
          this.contentGrpData[GlobalConstants.BANNER_CAROUSEL] = bannerContent;
        }
      });

    //listens page data from live preview
    this.cmnService.pageDataTologoObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        if (this.contentGrpData) {
          const bannerContent = this.contentGrpData[GlobalConstants.BANNER_CAROUSEL];
          let configurations = bannerContent.configurations;
          if (res.data.media.url !== '') {
            this.prepareMediaSet(res, bannerContent.id);
          }
          const checkJson = this.checkExistance(configurations.contentGroupPages, 'pageNum', res.number);
          // console.log(checkJson);
          if (checkJson.hasMatch) {// If there is configuration object already for the page number
            // Update the pages
            configurations.contentGroupPages[checkJson.matchedIndex] = {
              pageNum: res.number,
              title: res.data.heading,
              titleFontColor: res.data.hcolor,
              bgColor: res.data.bgcolor,
              bodyCopy: res.data.body,
              bodyCopyFontSize: this.fontSizeNumber(res.data.size),
              bodyCopyFontColor: res.data.bcolor,
              UiLayout: this.getUILayoutNameByID(res.data.layout),
              linkedAsset: res.data.media.url !== '' ? true : false,
              linkedAssetFileType: res.data.media.format,
              fileName: res.data.media.name,
              fullScreenCheckbox: res.data.fullScreenCheckbox,
            };
          } else {
            const bannerContentGroupPage: BannerContentGroupPage = {
              pageNum: res.number,
              title: res.data.heading,
              titleFontColor: res.data.hcolor,
              bgColor: res.data.bgcolor,
              bodyCopy: res.data.body,
              bodyCopyFontSize: this.fontSizeNumber(res.data.size),
              bodyCopyFontColor: res.data.bcolor,
              UiLayout: this.getUILayoutNameByID(res.data.layout),
              linkedAsset: res.data.media.url !== '' ? true : false,
              linkedAssetFileType: res.data.media.format,
              fileName: res.data.media.name,
              fullScreenCheckbox: res.data.fullScreenCheckbox,
            };
            configurations.contentGroupPages.push(bannerContentGroupPage);
          }
          this.contentGrpData[GlobalConstants.BANNER_CAROUSEL] = bannerContent;
        }
      });
  }
  openPopup(modal) {
    this.modalService.open(modal);
  }
  getPageError(data) {
    this.pageError.set(data[1], data[0])
  }
  resetPage() {
    this.pageError = new Map([[1, false], [2, false], [3, false]]);
  }
  goToErrorPage() {
    if (this.pageError.get(1) === true) {
      this.tabIndex = 3
    } else if (this.pageError.get(2) === true) {
      this.tabIndex = 4
    } else {
      this.tabIndex = 5
    }
  }
  getBannerDeviceData(data) {
    if (this.checkedId.has(data.id)) {
      this.checkedId.delete(data.id);
    } else {
      this.checkedId.set(data.id, true);
    }
    this.bannerDataForDevice.emit(this.checkedId);
  }
  openSendBannerCarouselToAccountModal(bannerCGID: string) {
    this.sendButtonText = GlobalConstants.BANNER_BUTTON_TEXT;
    this.bannerCarouselIdInfo = bannerCGID;
    this.sendNameToStore = this.displayBannerContentGroups.find(ele => ele.id === bannerCGID).configurations.publishedName;
    this.openModal(this.sendToAccountModal);
  }

  getSelectedStoreData(data) {
    this.sendToStoreService.sendBannerToStoreService(this.bannerCarouselIdInfo, data)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(sendToStoreResponse => {
        if (sendToStoreResponse['response-context'].statusCode === GlobalConstants.SUCCESS_RESPONSE_CODE) {
          this.isSendToStore = true;
        }
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  openPopupBanner(modal, pageNumber) {
    this.modalService.open(modal);
    this.whichPageDelete = pageNumber;
  }

  deletePages(which) {
    this.isPage3Created = false;
    let pagesLen = Object.entries(this.pages).length;
    this.pagelen = Object.entries(this.pages).length;
    if (pagesLen > 1) {
      delete this.pages["page" + (pagesLen)];
      this.pagelen -= 1;
    } else {
      this.page1.updated(undefined, undefined, '', 1);
    }
    let configurations;
    let updatedPages = [];

    if (typeof this.contentGrpData[GlobalConstants.BANNER_CAROUSEL].configurations === 'string') {
      configurations = JSON.parse(this.contentGrpData[GlobalConstants.BANNER_CAROUSEL].configurations) as BannerContentConfiguration;
    } else {
      configurations = this.contentGrpData[GlobalConstants.BANNER_CAROUSEL].configurations as BannerContentConfiguration;
    }
    configurations.contentGroupPages.splice(which, 1);
    configurations.contentGroupPages.forEach((e, i) => {
      e.pageNum = i + 1;
      updatedPages.push(e);
    });

    if (this.page1) {
      this.page1.updated(configurations, AssetLibraryConstants.BANNER_CONTENTS, 'banner');
    } else if (this.page2) {
      this.page2.updated(configurations, AssetLibraryConstants.BANNER_CONTENTS, 'banner');
    } else {
      this.page3.updated(configurations, AssetLibraryConstants.BANNER_CONTENTS, 'banner');
    }
  }

  // To hold all pages media objects and its metada.
  prepareMediaSet(res: any, promoContentId: string) {
    const checkJson = this.checkExistance(this.mediaObjects, 'pageNum', res.number);
    if (checkJson.hasMatch) {
      // Update the pages
      this.mediaObjects[checkJson.matchedIndex] = {
        id: promoContentId,
        media: res.data.media,
        pageNum: res.number
      };
      if (typeof res.data.media.fileObj === 'object' && res.data.media.fileObj) {
        this.mediaObjects[checkJson.matchedIndex].uploaded = true;
      }
    } else {
      const dataObj: any = {
        id: promoContentId,
        media: res.data.media,
        pageNum: res.number
      };
      if (typeof res.data.media.fileObj === 'object' && res.data.media.fileObj) {
        dataObj.uploaded = true;
      }
      this.mediaObjects.push(dataObj);
    }
    // console.log(this.mediaObjects);
  }
  //mini preview
  loadMiniPreview(gId: string, pageContent: any) {
    this.pageGrpForm = {
      bgcolor: pageContent ? pageContent.bgColor : '#0068B5',
      heading: pageContent ? pageContent.title : '',
      hcolor: pageContent ? pageContent.titleFontColor : '#ffffff',
      body: pageContent ? pageContent.bodyCopy : '',
      bcolor: pageContent ? pageContent.bodyCopyFontColor : '#ffffff',
      size: pageContent ? this.getFontSize(pageContent.bodyCopyFontSize) : GlobalConstants.MEDIUM,
      media: {
        url: (pageContent && pageContent.linkedAsset) ?
          environment.apiBaseUrlAsset + this.url + AssetLibraryConstants.BANNER_CONTENTS + AssetLibraryConstants.SLASH +
          gId + AssetLibraryConstants.SLASH + pageContent.pageNum.toString() : '',
        name: '',
        format: (pageContent && pageContent.linkedAsset) ? (pageContent.linkedAssetFileType) ? pageContent.linkedAssetFileType : '' : '',
        fileObj: ''
      },
      id: gId,    // adding created group id,
      layout: pageContent ? this.getUILayoutIDByName(pageContent.UiLayout) : 1,
      fullScreenCheckbox: pageContent ? pageContent?.fullScreenCheckbox ? 
      pageContent.fullScreenCheckbox : false : true,
    };

    return this.pageGrpForm;
  }
  getFontSize(size: number) {
    if (size === GlobalConstants.NUMBER_12) { return GlobalConstants.SMALL; }
    if (size === GlobalConstants.NUMBER_14) { return GlobalConstants.MEDIUM; }
    if (size === GlobalConstants.NUMBER_16) { return GlobalConstants.LARGE; }
  }
  getUILayoutIDByName(name: string) {
    if (name === GlobalConstants.TWO_COL_RIGHT_ASSET) {
      return 1;
    } else if (name === GlobalConstants.TWO_COL_LEFT_ASSET) {
      return 2;
    } else if (name === GlobalConstants.ONE_COL_MID_ASSET) {
      return 3;
    }
  }

  checkExistance(data, key, compValue) {
    const checkJSON = { hasMatch: false, matchedIndex: -1 };
    for (let index = 0; index < data.length; index += 1) {
      if (data[index][key] === compValue) {
        checkJSON.hasMatch = true;
        checkJSON.matchedIndex = index;
        break;
      }
    }
    return checkJSON;
  }

  setSideNav(value: string) {
    this.sideNav = value;
  }

  updateBCG() {

    const updateBannerContent: CreateBannerContentResponse = this.contentGrpData as CreateBannerContentResponse;
    //Once page is updated.
    const bannerContent = updateBannerContent.bannerCarousel;
    if (typeof bannerContent.configurations !== 'string') {
      bannerContent.configurations = JSON.stringify(bannerContent.configurations);
    }
    this.bannerContentService.putBannerContentById(JSON.stringify(bannerContent), updateBannerContent.bannerCarousel.id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(async (putBannerContentResponse: CreateBannerContentResponse) => {
        // Once the update call is successful, call a PUT call for the banner
        for (const each of this.mediaObjects) {
          if (each.uploaded) {
            await this.updateMedia(each);
          }
        }
        this.deviceExists = putBannerContentResponse.bannerCarousel.deviceExists;

        if (this.presentPage === this.profile_page) {
          this.openModal(this.showModal);
        } else if (this.editCheck && this.presentPage === this.assets_page && this.deviceExists) {
          this.openModal(this.applyModal);
        } else {
          this.pages = {};
          this.clickable = false;
          this.setIndex(0);
          this.getAllBannerContentsByUser();
        }
      });
  }

  changeLockContentStatus(id: string, eventObj: any, object: []) {
    const status = eventObj.target.checked ? GlobalConstants.LOCK_CONTENT_LOCK : GlobalConstants.LOCK_CONTENT_UNLOCK;
    this.cmnService.changeLockContentStatus(id, status, AssetLibraryConstants.BANNER_CONTENTS)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(response => {
        this.displayBannerContentGroups[this.displayBannerContentGroups.indexOf(object)].islocked =
          eventObj.target.checked;
      });
  }

  updateMedia(each) {
    return new Promise((resolve, reject) => {
      this.bannerContentService.putS3BannerContentByPageId(each.media.fileObj,
        each.media.name.split('.')
          .pop(), each.id, each.pageNum.toString())
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe((data) => {
          resolve(data);//To-Do: we should handle what if response code is other than 200
        },
          error => { // do something
          }
        );
    });
  }

  getAllBannerContentsByUser() {
    this.bannerContentService.getAllBannerContentByUser()
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getAllBannerContentResponse => {
        this.allBannerContentGroups = (getAllBannerContentResponse.bannerCarousel as BannerContent[]);
        this.configurations = [];
        this.sendBannerLength.emit(this.allBannerContentGroups.length);
        this.allBannerContentGroups.forEach(bannerContentGroup => {
          try {
            this.configurations.push(JSON.parse(bannerContentGroup.configurations) as BannerContentConfiguration);
          }
          catch (err) {
            console.log(err);
          }
        });
        // display Banner content groups using displayBannercontentgroups var as configurations is coming as string
        this.displayBannerContentGroups = [];
        this.allBannerContentGroups.forEach(ele => {
          try {
            ele.configurations = JSON.parse(ele.configurations);
          }
          catch (err) {
            console.log(err);
          }
          ele.createdByUser = (ele.createdByUser === this.userId) ? GlobalConstants.ME : ele.createdByUser;
          this.displayBannerContentGroups.push(ele);
        });
        this.displayBannerContentGroups.forEach(element => {
          // adding this custom property to know which Banner content is expanded
          // console.log('display banner content group:: ' + JSON.stringify(element));
          element.isExpanded = false;
          element.imageUrl = environment.apiBaseUrlAsset + this.envurl + element.id;
          element.previewTabIndex = 0; // For new implementation of preview IIT2_4661
          if (element.updateTime) {
            element.updateTime = new Date(element.updateTime);
            element.updateTimeDisplay = new Date(element.updateTime).toLocaleString()
              .replace(',', '');
          }
          // console.log(element.configurations);
          if (element && element.configurations && element?.configurations?.formFactor) {
            element.configurations.formFactor = Utils.getFormFactorNames(element.configurations.formFactor);
          }
          // fetch images from s3
          // console.log('fetch image: '+ element.id);
          this.fetchImagesForBannerCGPages(element.id);

          // converting date format:
          if (element && element.configurations) {
            if (element.configurations?.publishTime && !element.configurations.isPublishDateNow) {
              //changing it to old format
              element.configurations.publishTime = Utils.ChangetoOldFormat(element.configurations.publishTime);
            }
            if (element.configurations.expireTime && element.configurations.expireTime !== GlobalConstants.NEVER) {
              //changing it to old format
              element.configurations.expireTime = Utils.ChangetoOldFormat(element.configurations.expireTime);
            }
            if (element.configurations.expireTime && element.configurations.expireTime === GlobalConstants.NEVER) {
              element.configurations.expireTime = LanguageConstants.NEVER;
            }
          }

          // converting date for display purpose:
          if ((this.presentPage === this.profile_page)) {
            element.showOnDevice = false;
            element.addToPackage = false;
          }
          // For content expired notification
          element.isContentExpires = Utils.getExpiredContentdata(element);
        });

        this.sortBy('createDate');
        if (this.presentPage === this.profile_page) {
          this.displayBannerContentGroups.forEach((element, index) => {
            element.index = index;
          });
          this.selctedContGrpsForProfile = {
            contentGrps: [],
            showOnDevice: []
          };
        }

        if (this.profileStoreService?.currentWorkingProfile !== undefined) {
          const existingProfileData = JSON.parse(JSON.stringify(this.profileStoreService?.currentWorkingProfile));
          if (existingProfileData && (existingProfileData?.profileId === this.createProfileService.getProfileId())) {
            this.profileDataSet = existingProfileData as ProfileRequest;
            this.profileBannerCarouselData = this.profileDataSet.bannerCarousels;
            if (this.profileBannerCarouselData?.length) {

              this.displayBannerContentGroups.forEach(a => a.showOnDevice = a.addToPackage = false);
              this.selctedContGrpsForProfile.showOnDevice = [];
              if (existingProfileData?.bannerCarousels?.length === 1 && !existingProfileData?.bannerCarousels[0].showOnDevice && existingProfileData?.bannerCarousels[0].bannerCarouselId === undefined) {
                this.selctedContGrpsForProfile.contentGrps = [];

              } else {
                this.selctedContGrpsForProfile.contentGrps = existingProfileData.bannerCarousels;
              }
              this.selctedContGrpsForProfile.contentGrps.forEach((ele, ind) => {
                const contentIdInd = this.displayBannerContentGroups.findIndex(each => each.id === ele.bannerCarouselId);
                if (contentIdInd >= 0) {
                  this.displayBannerContentGroups[contentIdInd].addToPackage = true;
                  this.displayBannerContentGroups[contentIdInd].showOnDevice = ele.showOnDevice;
                  if (ele.showOnDevice) {
                    this.selctedContGrpsForProfile.showOnDevice.push(this.displayBannerContentGroups[contentIdInd].id);
                  }
                }
              });
            }
          }
        }
        if (this.showDevice) {
          if (this.selctedContGrpsForProfile.showOnDevice.length === 3) {
            const elementShowOnDevice = this.displayBannerContentGroups.filter(d => d.showOnDevice === true)
              .sort((bc1, bc2) => new Date(bc1.updateTime)?.getTime() - new Date(bc2.updateTime)?.getTime())[0];
            if (elementShowOnDevice) {
              this.displayBannerContentGroups.filter(x => x.id === elementShowOnDevice?.id)[0].showOnDevice = false;
              this.selctedContGrpsForProfile.showOnDevice = this.selctedContGrpsForProfile.showOnDevice
                .filter(item => item !== elementShowOnDevice.id);
              this.selctedContGrpsForProfile.contentGrps
                .filter(x => x.bannerCarouselId === elementShowOnDevice.id)[0].showOnDevice = false;
            }
          }
          if (this.selctedContGrpsForProfile.contentGrps.length === 6) {
            const element = this.displayBannerContentGroups.filter(d => d.addToPackage === true)
              .sort((bc1, bc2) => new Date(bc1.updateTime)?.getTime() - new Date(bc2.updateTime)?.getTime())[0];
            this.selctedContGrpsForProfile.contentGrps = this.selctedContGrpsForProfile.contentGrps
              .filter(x => x.bannerCarouselId !== element.id);
            this.displayBannerContentGroups.filter(x => x.id === element.id)[0].addToPackage = false;
          }
          this.displayBannerContentGroups[0].addToPackage = true;
          this.displayBannerContentGroups[0].showOnDevice = true;
          this.pushToSelectedGrps(0);
          this.selctedContGrpsForProfile.showOnDevice.push(this.displayBannerContentGroups[0].id);

          const bannerContentData: BannerCarousel = this.selctedContGrpsForProfile.contentGrps as BannerCarousel;
          this.createProfileService.updateProfile(this.createProfileService.getProfileId(), { bannerCarousels: bannerContentData })
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(data => {
              const profileUpdateResponse = data.profile as ProfileUpdateResponse;
              this.profileStoreService.updateProfileData(profileUpdateResponse);
            });
        }
      },
        error => {
          // do something
        });
  }

  setTabNavigation(option) {
    this.radioType = this.bannerFunction = option;
  }

  cancel() {
    this.getAllBannerContentsByUser();
    this.setIndex(0);
    this.dataService.setBannerContent(undefined);
    this.mediaObjects = [];
    this.pages = {};
    if (this.lCGlayout !== 1) {
      this.lCGlayout = 1;
    }
    this.clickable = false;
    this.editCheck = false;
    this.isNavigated = false;
  }

  setCreatedGrpID(data) {
    this.buttonName = this.bannerContentService.buttonName;
    if (this.isNavigated && this.bannerFunction === "Default") {
      this.bannerFunction = GlobalConstants.CONTENT_PAGES;
      this.cmnService.emitMetadataCheck(true, this.bannerFunction);
    }
    if (typeof data === 'object' && data.cancel) {
      this.setIndex(0);
      this.pages = {};
      this.editCheck = false;
    } else {
      this.page = 1; // set pagination to 1
      this.pages.page1 = true;
      this.isPage3Created = this.checkPages();
      this.clickable = true;
      this.contentGrpData = data;
      if (typeof this.contentGrpData[GlobalConstants.BANNER_CAROUSEL][GlobalConstants.CONFIGURATIONS] === 'string') {
        this.contentGrpData[GlobalConstants.BANNER_CAROUSEL][GlobalConstants.CONFIGURATIONS] =
          JSON.parse(this.contentGrpData[GlobalConstants.BANNER_CAROUSEL][GlobalConstants.CONFIGURATIONS]) as BannerContentConfiguration;
      }
      if (this.contentGrpData[GlobalConstants.BANNER_CAROUSEL][GlobalConstants.CONFIGURATIONS].customURL !== '') {
        this.customURL = this.contentGrpData[GlobalConstants.BANNER_CAROUSEL][GlobalConstants.CONFIGURATIONS].customURL;
      } else {
        this.customURL = '';
      }
      this.showBannerCarouselName = this.contentGrpData[GlobalConstants.BANNER_CAROUSEL].configurations.publishedName
      if (this.bannerFunction === GlobalConstants.URL_EXPERIENCE) {
        this.contentGrpData[GlobalConstants.BANNER_CAROUSEL].configurations.contentGroupPages = [];
        this.setIndex(2);
        this.isNavigated = false;
        this.radioType = this.bannerFunction = GlobalConstants.URL_EXPERIENCE;
      } else {
        this.contentGrpData[GlobalConstants.BANNER_CAROUSEL].configurations.customURL = '';
        this.setIndex(3);
        this.isNavigated = false;
        this.radioType = this.bannerFunction = GlobalConstants.CONTENT_PAGES;
      }
    }
    //this.mediaObjects = [];
    if (this.lCGlayout !== 1) {
      this.lCGlayout = 1;
    }
  }

  setTab(bannerFunction) {
    this.radioType = this.bannerFunction = bannerFunction;
    if (this.lCGlayout !== 1) {
      this.lCGlayout = 1;
    }
    if (bannerFunction === GlobalConstants.URL_EXPERIENCE) {
      this.customURL = '';
      this.contentGrpData[GlobalConstants.BANNER_CAROUSEL].configurations.contentGroupPages = [];
      this.imageURL = this.contentGrpData[GlobalConstants.BANNER_CAROUSEL].configurations.imageURL;
      this.pages = {};
      this.cmnService.emitMetadataCheck(true, bannerFunction);
      this.setIndex(2);
    } else {
      this.mediaObjects = [];
      this.page = 1; // set pagination to 1
      this.pages.page1 = true;
      this.isPage3Created = this.checkPages();
      this.contentGrpData[GlobalConstants.BANNER_CAROUSEL].configurations.customURL = '';
      this.cmnService.emitMetadataCheck(true, bannerFunction);
      this.setIndex(3);
    }
  }

  /*when user opens pages*/
  setPreviewLayout(data) {
    this.lCGlayout = data;
  }

  setIndex(value: number) {
    this.tabIndex = value;
  }

  setLayout(selected) {
    this.lCGlayout = selected;
    this.cmnService.emitLayout(selected);
  }

  refreshBannerContentdata() {
    this.getAllBannerContentsByUser();
    this.setIndex(0);
    this.mediaObjects = [];
  }

  redirectToLogin() {
    this.router.navigateByUrl(RouterConstants.LOGIN_PAGE_LINK);
  }

  trackByConfiguration(index: number, el: string): number {
    return index;
  }

  fetchImagesForBannerCGPages(bannerCGId: string) {
    this.displayBannerContentGroups.forEach(element => {
      if (element.id === bannerCGId && element.configurations && element.configurations.contentGroupPages) {
        element.configurations.contentGroupPages.forEach(page => {
          if (page.linkedAsset) {
            const reader = new FileReader();

            this.bannerContentService.getBannerContentByPageId(bannerCGId, page.pageNum)
              .pipe(takeUntil(this.ngUnsubscribe))
              .pipe(first())
              .subscribe(imageData => {
                reader.addEventListener('load', () => {
                  page.image = reader.result;
                }, false);

                if (imageData) {
                  reader.readAsDataURL(imageData);
                }
              },
                error => {
                  // do something
                });
          }
        });
      }
    });
  }


  getDetailsOfBannerCG(id: string) {
    this.displayBannerContentGroups.forEach(element => {
      if (element.id === id) {
        element.isExpanded = !element.isExpanded
        element.previewTabIndex = 0;// IIT2_4661;
        this.cmnService.scrollToBottom(id);
      }
    });
  }

  sortBy(sortValue: string) {
    switch (sortValue) {
      case 'createDate': {
        this.sortValue = GlobalConstants.CREATED_DATE;
        this.displayBannerContentGroups.sort((banner1, banner2) => banner2.updateTime - banner1.updateTime);
        break;
      }
      case 'groupName': {
        this.sortValue = GlobalConstants.GROUP_NAME;
        this.displayBannerContentGroups.sort((banner1, banner2) =>
          banner1.configurations.publishedName.localeCompare(banner2.configurations.publishedName));
        break;
      }

      default:
        break;
    }
  }

  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  openDeleteModal(bannerCGID: string) {
    this.bannerCGToDelete = this.displayBannerContentGroups.find(ele => ele.id === bannerCGID).id;
    this.bannerCGToDeleteName = this.displayBannerContentGroups.find(ele => ele.id === bannerCGID).configurations.publishedName;
    this.openModal(this.deleteModal);
  }

  editBanner(bannerCGID: string) {
    this.pages = {};
    const bannerCGToEdit = this.displayBannerContentGroups.find(ele => ele.id === bannerCGID);
    if (bannerCGToEdit.configurations.contentGroupPages) {
      bannerCGToEdit.configurations.contentGroupPages.forEach(page => {
        page.image = undefined;
      });
    }
    this.dataService.setBannerContent(bannerCGToEdit);
    this.editCheck = true;
    for (let each of bannerCGToEdit.configurations.contentGroupPages) {
      if (each.pageNum === 1) {
        this.pages.page1 = true;
      }
      if (each.pageNum === 2) {
        this.pages.page2 = true;
      }
      if (each.pageNum === 3) {
        this.pages.page3 = true;
      }
    }

    const tempBannerCarousel = bannerCGToEdit as BannerContent;
    this.pagelen = Object.entries(this.pages).length;
    this.contentGrpData = {
      bannerCarousel: tempBannerCarousel,
      responseContext: {}
    }; // set data to cntGrpData to show in pages
    this.showBannerCarouselName = bannerCGToEdit.configurations.publishedName;
    this.imageURL = bannerCGToEdit.configurations.imageURL;

    let checkExistance = (this.contentGrpData[GlobalConstants.BANNER_CAROUSEL].configurations.customURL !== '' && this.contentGrpData[GlobalConstants.BANNER_CAROUSEL].configurations.contentGroupPages.length > 0) ? true : false;
    if (!checkExistance) {
      if (this.contentGrpData[GlobalConstants.BANNER_CAROUSEL].configurations.customURL !== undefined && this.contentGrpData[GlobalConstants.BANNER_CAROUSEL].configurations.customURL !== ''
        && this.contentGrpData[GlobalConstants.BANNER_CAROUSEL].configurations.contentGroupPages.length === 0) {
        this.radioType = this.bannerFunction = GlobalConstants.URL_EXPERIENCE;
      } else {
        this.radioType = this.bannerFunction = GlobalConstants.CONTENT_PAGES;
      }
    }
    this.setIndex(1);
  }

  deleteBannerCG(bannerCGID: string) {
    // delete Banner API call
    this.bannerContentService.deleteBannerContentById(bannerCGID)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(deleteResponse => {
        const index = this.displayBannerContentGroups.findIndex(d => d.id === bannerCGID); // find index in your array
        if (index >= 0) {
          this.displayBannerContentGroups.splice(index, 1); // remove element from array
        }
        this.closeModal(this.deleteModal);
      },
        error => {
          // do something
          this.closeModal(this.deleteModal);
        });
  }

  fontSizeNumber(size) {
    if (size === GlobalConstants.SMALL) { return GlobalConstants.NUMBER_12; }
    if (size === GlobalConstants.MEDIUM) { return GlobalConstants.NUMBER_14; }
    if (size === GlobalConstants.LARGE) { return GlobalConstants.NUMBER_16; }
  }

  getUILayoutNameByID(id) {// TODO - Confirm with Sujay if layout name is correct
    if (id === 1) {
      return GlobalConstants.TWO_COL_RIGHT_ASSET;
    } else if (id === 2) {
      return GlobalConstants.TWO_COL_LEFT_ASSET;
    } else if (id === 3) {
      return GlobalConstants.ONE_COL_MID_ASSET;
    }
  }

  addPage() {
    const keyLen = Object.keys(this.pages).length;
    if (keyLen === 0) {
      this.pages.page1 = true;
      this.setIndex(3);
    } else if (keyLen === 1) {
      this.pages.page2 = true;
      this.setIndex(4);
    } else {
      this.pages.page3 = true;
      this.setIndex(5);
    }
    this.isPage3Created = this.checkPages();
    this.pagelen = Object.entries(this.pages).length;
  }

  checkPages() {
    if (this.pages.page1 && this.pages.page2 && this.pages.page3) {
      return true;
    }

    return false;
  }

  addNewBannerCarousel() {
    this.editCheck = false; //To show new b.c title always when user clicks on new btn IIT2-4675
    this.mediaObjects = [];
    this.selctedContGrpsForProfile.contentGrps = []
    this.imageURL = '';
    this.radioType = this.bannerFunction = GlobalConstants.CONTENT_PAGES;
    this.dataService.setBannerContent(undefined);
    this.tabIndex = 1;
  }

  pushToSelectedGrps(ind: number) {
    this.selctedContGrpsForProfile.contentGrps.push({
      "bannerCarouselId": this.displayBannerContentGroups[ind].id,
      "showOnDevice": this.displayBannerContentGroups[ind].showOnDevice
    });
  }

  //this function will be used in multiple places to set addToPackage, showOnDevice to true/false ---> for AddToProfile
  setPackageAndShowOnDeviceVal(index: number, value: boolean) {
    this.displayBannerContentGroups[index].showOnDevice = this.displayBannerContentGroups[index].addToPackage = value;
  }

  //This function gets called when user selects/deselect show on device / addToPackage
  addToProfile(eventObj: any, index: number, eventSource: string) {
    //for show on device
    if (eventSource === GlobalConstants.SHOW_ON_DEVICE) {
      //if switching show on device from one to other
      if (eventObj.target.checked) {
        this.selctedContGrpsForProfile.showOnDevice.push(this.displayBannerContentGroups[index].id);
        let checkIndContentGrps = this.selctedContGrpsForProfile.contentGrps.findIndex(d => d.bannerCarouselId === this.displayBannerContentGroups[index].id);
        this.selctedContGrpsForProfile.contentGrps[checkIndContentGrps].showOnDevice = true;
        this.displayBannerContentGroups[index].showOnDevice = true;
      }
      else {
        this.selctedContGrpsForProfile.showOnDevice = this.selctedContGrpsForProfile.showOnDevice.
          filter(item => item !== this.displayBannerContentGroups[index].id);
        const checkIndContentGrps = this.selctedContGrpsForProfile.contentGrps
          .findIndex(d => d.bannerCarouselId === this.displayBannerContentGroups[index].id);
        this.selctedContGrpsForProfile.contentGrps[checkIndContentGrps].showOnDevice = false;
        this.displayBannerContentGroups[index].showOnDevice = false;
      }
    } else if (eventSource === GlobalConstants.ADD_TO_PACKAGE) {
      if (eventObj.target.checked) {
        if (this.selctedContGrpsForProfile.contentGrps?.length <= 6) {
          this.displayBannerContentGroups[index].addToPackage = eventObj.target.checked;
          this.pushToSelectedGrps(index);
        } else {
          eventObj.target.checked = false;
        }
      } else {
        if (this.displayBannerContentGroups[index].showOnDevice) {
          this.selctedContGrpsForProfile.showOnDevice = this.selctedContGrpsForProfile.showOnDevice.filter(item => item !== this.displayBannerContentGroups[index].id);
        }
        this.setPackageAndShowOnDeviceVal(index, false);
        let checkInd = this.selctedContGrpsForProfile.contentGrps.findIndex(d => d.bannerCarouselId === this.displayBannerContentGroups[index].id);
        if (checkInd >= 0) {
          this.selctedContGrpsForProfile.contentGrps.splice(checkInd, 1);
        }
      }
    }
  }

  sendToProfile(action: string) {
    if (action === GlobalConstants.SEND) {
      if (!this.selctedContGrpsForProfile?.contentGrps?.length) {
        this.selctedContGrpsForProfile.contentGrps = [{
          'bannerCarouselId': undefined,
          'showOnDevice': false,
        }];
      }
      this.cmnService.emitDataToProfile({ page: GlobalConstants.BANNER_CONTENT_GROUP, dataSet: this.selctedContGrpsForProfile.contentGrps });
      //gtm(google tag manager)
      window['dataLayer'].push({
        'banner_carousel_added': true
      });
    } else {
      this.cmnService.emitDataToProfile({ page: GlobalConstants.BANNER_CONTENT_GROUP, dataSet: GlobalConstants.SKIP });
    }
    this.cmnService.scrollTopInitial();
  }

  duplicateAndEditBanner(bannerContentId: string) {
    const bannerGrpToDuplicate = this.displayBannerContentGroups.find(ele => ele.id === bannerContentId);
    const bannerContentConfig = bannerGrpToDuplicate.configurations;
    if (bannerContentConfig.contentGroupPages) {
      bannerContentConfig.contentGroupPages.forEach(page => {
        page.image = undefined;
      });
    }

    if (bannerContentConfig?.publishTime && !bannerContentConfig?.isPublishDateNow) {
      //changing it to new format
      bannerContentConfig.publishTime = Utils.changeSaveDateFormat(bannerContentConfig?.publishTime);

    }
    if (bannerContentConfig?.expireTime && bannerContentConfig?.expireTime !== GlobalConstants.NEVER) {
      //changing it to new format
      bannerContentConfig.expireTime = Utils.changeSaveDateFormat(bannerContentConfig?.expireTime);

    }

    const bannerToCreate: BannerContentConfiguration = {
      publishedName: `Copy of ${bannerContentConfig.publishedName}`,
      internalName: bannerContentConfig.internalName,
      type: bannerContentConfig.type,
      contentGroupPages: bannerContentConfig.contentGroupPages,
      formFactor: bannerContentConfig.formFactor,
      imageFile: bannerContentConfig.imageFile,
      customURL: bannerContentConfig.customURL,
      publishTime: bannerContentConfig.publishTime,
      expireTime: bannerContentConfig.expireTime,
      isPublishDateNow: bannerContentConfig.isPublishDateNow,
      isPublishExpiryNever: bannerContentConfig.isPublishExpiryNever,
      bgColor: bannerContentConfig?.bgColor ? bannerContentConfig?.bgColor : '#000000'
    };

    this.bannerContentService.createBannerContent(JSON.stringify(bannerToCreate))
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(async createBannerCarouselResponse => {
        this.getDetailsOfBannerCG(bannerContentId);
        const createBannerCarouselResponseObj: CreateBannerContentResponse = createBannerCarouselResponse as CreateBannerContentResponse;
        const bannerContentViewModel: BannerContentViewModel = createBannerCarouselResponseObj.bannerCarousel as unknown as BannerContentViewModel;
        bannerContentViewModel.configurations = JSON.parse(createBannerCarouselResponseObj.bannerCarousel.configurations) as BannerContentConfiguration;

        // Loop and duplicate images
        await this.duplicateBannerLivePreviewImage(bannerGrpToDuplicate, bannerContentViewModel);
        if (bannerGrpToDuplicate?.configurations && bannerGrpToDuplicate.configurations.contentGroupPages?.length) {
          for (let page of bannerGrpToDuplicate.configurations.contentGroupPages) {
            await this.duplicateBannerContentImage(bannerGrpToDuplicate, bannerContentViewModel, page);
          }
        }

        if (bannerContentViewModel && bannerContentViewModel.configurations) {
          if (bannerContentViewModel.configurations?.publishTime && !bannerContentViewModel.configurations.isPublishDateNow) {
            //changing it to old format
            bannerContentViewModel.configurations.publishTime = Utils.ChangetoOldFormat(bannerContentViewModel.configurations.publishTime);
          }
          if (bannerContentViewModel.configurations.expireTime && bannerContentViewModel.configurations.expireTime !== GlobalConstants.NEVER) {
            //changing it to old format
            bannerContentViewModel.configurations.expireTime = Utils.ChangetoOldFormat(bannerContentViewModel.configurations.expireTime);
          }
        }

        this.dataService.setBannerContent(bannerContentViewModel);
        this.editCheck = true;
        for (let each of bannerContentViewModel.configurations.contentGroupPages) {
          if (each.pageNum === 1) {
            this.pages.page1 = true;
          }
          if (each.pageNum === 2) {
            this.pages.page2 = true;
          }
          if (each.pageNum === 3) {
            this.pages.page3 = true;
          }
        }
        this.contentGrpData = {
          bannerCarousel: bannerContentViewModel,
          responseContext: {}
        };
        const tempViewModel: any = bannerContentViewModel;
        tempViewModel.createdByUser = (tempViewModel.createdByUser === this.userId) ? GlobalConstants.ME : tempViewModel.createdByUser;
        tempViewModel.isExpanded = false;
        tempViewModel.previewTabIndex = 0;// IIT2_4661
        if (tempViewModel.updateTime) {
          tempViewModel.updateTime = new Date(tempViewModel.updateTime);
          tempViewModel.updateTimeDisplay = new Date(tempViewModel.updateTime).toLocaleString()
            .replace(',', '');
        }
        tempViewModel.isDeleted = false;

        tempViewModel.addToPackage = tempViewModel.showOnDevice = false;
        this.displayBannerContentGroups.unshift(tempViewModel);
        if (this.presentPage === this.profile_page) {
          this.displayBannerContentGroups.forEach((element, index) => {
            element.index = index;
          });
        }
        this.sortBy(GlobalConstants.CREATED_DATE);
        this.showBannerCarouselName = bannerToCreate.publishedName;
        this.imageURL = bannerContentConfig.imageURL;
        this.page = 1;
        let checkExistance = (this.contentGrpData[GlobalConstants.BANNER_CAROUSEL].configurations.customURL !== '' && this.contentGrpData[GlobalConstants.BANNER_CAROUSEL].configurations.contentGroupPages.length > 0) ? true : false;
        if (!checkExistance) {
          if (this.contentGrpData[GlobalConstants.BANNER_CAROUSEL].configurations.customURL !== undefined &&
            this.contentGrpData[GlobalConstants.BANNER_CAROUSEL].configurations.customURL !== '' && this.contentGrpData[GlobalConstants.BANNER_CAROUSEL].configurations.contentGroupPages.length === 0) {
            this.radioType = this.bannerFunction = GlobalConstants.URL_EXPERIENCE;
          } else {
            this.radioType = this.bannerFunction = GlobalConstants.CONTENT_PAGES;
          }
        }
        this.setIndex(1);
      },
        error => {

        });
  }

  duplicateBannerLivePreviewImage(bannerContent, newBannerContent) {
    return new Promise((resolve, reject) => {
      if (bannerContent.configurations) {
        this.bannerContentService.getS3BannerContentById(bannerContent.id)
          .pipe(takeUntil(this.ngUnsubscribe))
          .pipe(first())
          .subscribe(imageData => {
            this.bannerContentService.uploadImage(imageData, newBannerContent.id, 'png') // Check how to get image type
              .pipe(takeUntil(this.ngUnsubscribe))
              .pipe(first())
              .subscribe((data) => {
                resolve(data);//ToDo: Need to add reject too.
              },
                error => {
                  // do something
                });
          },
            error => {
              // do something
            });
      } else {
        resolve({});//ToDo: Just to continue the flow sending the empty Obj
      }
    });
  }

  duplicateBannerContentImage(bannerContent: any, newBannerContent: any, page: any) {
    return new Promise((resolve, reject) => {
      if (page.linkedAsset) {
        this.bannerContentService.getBannerContentByPageId(bannerContent.id, page.pageNum)
          .pipe(takeUntil(this.ngUnsubscribe))
          .pipe(first())
          .subscribe(imageData => {
            this.bannerContentService.putS3BannerContentByPageId(imageData, 'png', newBannerContent.id, page.pageNum) // Check how to get image type
              .pipe(takeUntil(this.ngUnsubscribe))
              .pipe(first())
              .subscribe((data) => {
                resolve(data);//ToDo: Need to add reject too.
              },
                error => {
                  // do something
                });
          },
            error => {
              // do something
            });
      } else {
        resolve({});//ToDo: just sending empty, to continue the flow;
      }
    });
  }

  redirectToList() {
    this.pages = {};
    this.clickable = false;
    this.setIndex(0);
    this.closeModal(this.showModal);
    this.getAllBannerContentsByUser();
  }

  redirectToApplyList() {
    this.pages = {};
    this.clickable = false;
    this.setIndex(0);
    this.closeModal(this.applyModal);
    this.getAllBannerContentsByUser();
  }

  showOnDevice() {
    this.showDevice = true;
    this.redirectToList();
  }

  closeShowOnDevice() {
    this.showDevice = false;
    this.selctedContGrpsForProfile.contentGrps = [];
    this.selctedContGrpsForProfile.showOnDevice = [];
    this.redirectToList();
  }

  applyToDevice(applyDevice: boolean) {
    const updateBannerContent: CreateBannerContentResponse = this.contentGrpData as CreateBannerContentResponse;
    //Once page is updated.
    const bannerContent = updateBannerContent.bannerCarousel;
    if (typeof bannerContent.configurations !== 'string') {
      bannerContent.configurations = JSON.stringify(bannerContent.configurations);
    }
    bannerContent.ispushedToDevice = applyDevice;
    bannerContent.showOnDevice = applyDevice;
    if (!applyDevice) {
      bannerContent.deviceExists = false;
    }
    else {
      bannerContent.deviceExists = this.deviceExists;
    }
    this.bannerContentService.putBannerContentById(JSON.stringify(bannerContent), updateBannerContent.bannerCarousel.id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(async (putBannerContentResponse: CreateBannerContentResponse) => {
        this.redirectToApplyList();
      },
        error => {

        });
  }

  closeApplyDevice() {
    this.showDevice = false;
    this.selctedContGrpsForProfile.contentGrps = [];
    this.selctedContGrpsForProfile.showOnDevice = [];
    this.redirectToApplyList();
  }

  navigate() {
    this.isNavigated = true;
    this.newContentGrpDataToNavigate = this.contentGrpData;
    this.newContentGrpDataToNavigate[GlobalConstants.BANNER_CAROUSEL].configurations.formFactor =
      Utils.getFormFactorNames(this.newContentGrpDataToNavigate[GlobalConstants.BANNER_CAROUSEL].configurations.formFactor);
    if (
      this.newContentGrpDataToNavigate.promotionalContent &&
      this.newContentGrpDataToNavigate.promotionalContent.configurations
    ) {
      if (
        this.newContentGrpDataToNavigate.promotionalContent.configurations?.publishTime &&
        !this.newContentGrpDataToNavigate.promotionalContent.configurations.isPublishDateNow
      ) {
        //changing it to old format
        this.newContentGrpDataToNavigate.promotionalContent.configurations.publishTime = Utils.ChangetoOldFormat(
          this.newContentGrpDataToNavigate.promotionalContent.configurations.publishTime
        );
      }
      if (
        this.newContentGrpDataToNavigate.promotionalContent.configurations.expireTime &&
        this.newContentGrpDataToNavigate.promotionalContent.configurations.expireTime !== GlobalConstants.NEVER
      ) {
        //changing it to old format
        this.newContentGrpDataToNavigate.promotionalContent.configurations.expireTime = Utils.ChangetoOldFormat(
          this.newContentGrpDataToNavigate.promotionalContent.configurations.expireTime
        );
      }
    }
    this.dataService.setBannerContent(this.newContentGrpDataToNavigate[GlobalConstants.BANNER_CAROUSEL]);
    if (this.bannerFunction === GlobalConstants.CONTENT_PAGES) {
      this.bannerFunction = "Default";
    }
    this.cmnService.emitMetadataCheck(false, this.bannerFunction);
    this.setIndex(1);
    this.clickable = false;
  }

  tabTrimString(data: string) {
    return Utils.trimString(data)
  }

  //IIT2_4661
  previewNavigate(ind, id) {
    this.displayBannerContentGroups.forEach(element => {
      if (element.id === id) {
        element.previewTabIndex = ind;
      }
    });
  }

}
